var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.logoComponent,_vm._b({tag:"component",on:{"click":function($event){return _vm.$emit('click')}}},'component',{ ..._vm.$attrs, ..._vm.$props },false),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }